import React from "react"
import { FEATURES } from "../constants"

export const FeatureSections: React.FC = () => (
  <>
    {FEATURES.map((f, i) => (
      <section key={i} className="bg-[#1a1a1a] py-20">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-8">
          <div className={`flex flex-col lg:flex-row gap-16 items-center ${i % 2 === 1 ? "lg:flex-row-reverse" : ""}`}>
            <div className="flex-1">
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-2xl bg-emerald-500/10 text-emerald-400 mb-6">
                {f.icon}
              </div>
              <h2 className="text-4xl font-black text-white mb-4">{f.title}</h2>
              <p className="text-neutral-400 text-lg leading-relaxed max-w-md">{f.body}</p>
            </div>
            <div className="flex-1 relative">
              <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
                <img src={f.img} alt={f.alt} className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
              </div>
              <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-emerald-400 rounded-full -z-10 opacity-60" />
            </div>
          </div>
        </div>
      </section>
    ))}
  </>
)